import { render, staticRenderFns } from "./SlcCollabCreateNewListBtn.vue?vue&type=template&id=7f1ba522&"
import script from "./SlcCollabCreateNewListBtn.vue?vue&type=script&lang=ts&"
export * from "./SlcCollabCreateNewListBtn.vue?vue&type=script&lang=ts&"
import style0 from "./SlcCollabCreateNewListBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports